import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

import { defaultMeta } from '@enums/common';

export const HEADER_FONT_SIZE = 14;

export const CHANGE_MONITORING_TABS_NAMES = {
	activeChanges: 'Active Changes',
	changeLog: 'Change Log',
};

export const EChangeMonitorActions = {
	SEND_TO_RUNNING: 'SEND_TO_RUNNING',
	SEND_ALL_ACCEPTED: 'SEND_ALL_ACCEPTED',
	CANCEL: 'CANCEL',
	CANCEL_ALL_ERRORS: 'CANCEL_ALL_ERRORS',
	TRY_AGAIN: 'TRY_AGAIN',
} as const;

export const EChangeMonitorStatuses = {
	CANDIDATE_PENDING: 'CANDIDATE_PENDING',
	CANDIDATE_ACCEPTED: 'CANDIDATE_ACCEPTED',
	CANDIDATE_ERROR: 'CANDIDATE_ERROR',
	RUNNING_PENDING: 'RUNNING_PENDING',
	RUNNING_ERROR: 'RUNNING_ERROR',
	CANCELED: 'CANCELED',
} as const;

export const EChangeMonitorErrorTypes = {
	SUCCESS: 'SUCCESS',
	ERROR: 'ERROR',
} as const;

export type TChangeMonitorAction = TValueOfStringRecord<typeof EChangeMonitorActions>

const DEFAULT_TAB = {
	page: defaultMeta.page,
	pageSize: defaultMeta.pageSize,
	sortDirection: false,
	sortFieldName: null,
	searchValue: '',
	filter: {},
};

export const DEFAULT_TABS = {
	[CHANGE_MONITORING_TABS_NAMES.activeChanges]: DEFAULT_TAB,
	[CHANGE_MONITORING_TABS_NAMES.changeLog]: DEFAULT_TAB,
};

export const CHANGE_MONITORING_TABS = [
	{
		title: CHANGE_MONITORING_TABS_NAMES.activeChanges,
		value: CHANGE_MONITORING_TABS_NAMES.activeChanges,
		isVisible: true,
	},
	{
		title: CHANGE_MONITORING_TABS_NAMES.changeLog,
		value: CHANGE_MONITORING_TABS_NAMES.changeLog,
		isVisible: true,
	},
];

export const CANCEL_PARAMETER_QUESTION = 'Are you sure you want to cancel this parameter update?';
export const CANCEL_PARAMETER_QUESTION_WITH_FILTER = 'Are you sure you want to cancel filtered error parameters?';
export const CANCEL_ALL_PARAMETERS_QUESTION = 'Are you sure you want to cancel all error parameters?';

export const RESEND_SINGLE_PARAMETER_QUESTION = 'Are you sure you want to resend the single parameter?';
export const RESEND_SINGLE_PARAMETER_SUBTEXT = `
	Resending this parameter to running will impact the service.
	It is recommended to edit the parameter and submit it to the Candidate configuration first.
	Once all necessary changes for all failed parameters are accepted,
	you can apply them all at once using "Send Accepted to Running" to reduce service disruptions.
`;

export const SEND_SINGLE_PARAMETER_QUESTION = `
	Warning: Applying this change will impact the service.
	It is recommended to send all parameters to running at once rather than one by one,
	as each individual action restarts services.
`;
export const SEND_SINGLE_PARAMETER_SUBTEXT = `Are you sure you want to proceed with this single action`;

export const SEND_ALL_PARAMETER_QUESTION = 'Are you sure you want to proceed with sending all accepted parameters to running?';
export const SEND_ALL_PARAMETER_QUESTION_FILTER = 'Are you sure you want to proceed with sending filtered accepted parameters to running?';
export const SEND_ALL_PARAMETER_SUBTEXT = `
	This action cannot be undone and will restart the service.
`;
